import React from 'react'
import {getBookingEngineTranslations} from "@assets/js/functions/helpers";
const translations = getBookingEngineTranslations();

const ADULTS = 'adults'
const KIDS   = 'children'
const BABIES = 'baby'

export default class CounterMultiple extends React.Component {
    state = {
        minLimit: 0,
        maxLimit: 9,
        counters: [
            {
                key: 'key',
                value: 2,
                title: 'title',
                subtitle: 'subtitle',
            }
        ]
    }

    componentDidMount() {
        const {counters} = this.props

        if (!counters) return
        this.setState({counters})
    }

    componentDidUpdate(prevProps, prevState) {
      if (prevProps.counters !== this.props.counters && this.props.readOnly) {
        this.setState({ counters: this.props.counters });
      }
    }

    changeCounterValue = (changingCounter, action) => {
        const guestsTotal = this.getGuestsTotal(this.state.counters)

        if (
            changingCounter !== BABIES &&
            action === 'increment' &&
            guestsTotal >= this.props.guestsLimit
        ) {
            return
        }

        const {adultsLimit, kidsLimit, babiesLimit} = this.props
        const adultsNumber = this.state.counters.filter(
            counter => counter.key === ADULTS
        )[0].value

        const countersChanged = this.state.counters.map(counter => {
            if (counter.key !== changingCounter) return counter

            if (
                (counter.key === ADULTS && action === 'increment' && adultsNumber >= adultsLimit) ||
                (counter.key === ADULTS && action === 'decrement' && adultsNumber === 1) ||
                (counter.key === KIDS && action === 'increment' && counter.value >= kidsLimit) ||
                (counter.key === BABIES && action === 'increment' && counter.value >= babiesLimit)
            ) {
                return {
                    ...counter
                }
            } else {
                return {
                    ...counter,
                    value: this.getValidCounterValue(action, counter.value)
                }
            }
        })

        this.setState(
            {
                counters: countersChanged
            },
            () => {
                if (this.props.onChange) {
                    this.props.onChange(this.state.counters)
                }
            }
        )
    }

    getValidCounterValue = (action, value) => {
        const {minLimit, maxLimit} = this.state
        value = parseInt(value)

        if (action === 'increment') {
            return maxLimit > value ? value + 1 : value
        }

        return minLimit < value ? value - 1 : value
    }

    getGuestsTotal = counters => {
        return counters.reduce(
            (total, counter) => {
                if (counter.key === BABIES) {
                    return total
                }

                return total + (parseInt(counter.value, 10) || 0)
            },
            0
        )
    }

    render() {
        const {counters} = this.state
        return (
            <div className="filters">
                {counters.map((counter, index) => {
                    return (
                        <div key={index} className="filter_row">
                            <div className="filter_row__column">
                                <div className="filter_row__column__value">{counter.value}</div>
                            </div>
                            <div className="filter_row__labels">
                                <div className="filter_row__labels__name">
                                    {counter.title}
                                    {(counter.key === 'baby') && (
                                        <span className="filter_row__labels__additional">
                      {' ' + translations['counter.description.additional']}
                    </span>
                                    )}
                                </div>
                                <div className="filter_row__labels__desc">
                                    {counter.subtitle}
                                </div>
                            </div>
                            {!this.props.readOnly && (
                                <div className="filter_row__buttons buttons_increment filter_row__buttons--fixwidth">
                                    <button
                                        type="button"
                                        onClick={() =>
                                            this.changeCounterValue(counter.key, 'decrement')
                                        }
                                    >
                                        -
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() =>
                                            this.changeCounterValue(counter.key, 'increment')
                                        }
                                    >
                                        +
                                    </button>
                                </div>
                            )}
                        </div>
                    )
                })}
                {this.props.children}
            </div>
        )
    }
}

